exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1rmImKqDO04zBnbCS7bfRH{width:100%}html[dir=ltr] ._1rmImKqDO04zBnbCS7bfRH{text-align:left}html[dir=rtl] ._1rmImKqDO04zBnbCS7bfRH{text-align:right}", ""]);

// exports
exports.locals = {
	"selectedPeopleList": "_1rmImKqDO04zBnbCS7bfRH"
};